import { render, staticRenderFns } from "./TeamLink.vue?vue&type=template&id=21886bb6&scoped=true&"
import script from "./TeamLink.vue?vue&type=script&lang=js&"
export * from "./TeamLink.vue?vue&type=script&lang=js&"
import style0 from "./TeamLink.vue?vue&type=style&index=0&id=21886bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21886bb6",
  null
  
)

export default component.exports